import React from "react";

import { Modal } from "../../../../components/Modal/Modal";
import { useString, useStrings } from "../../../../localization/localizationHelpers";
import * as styles from "../../GameConceptPage.module.css";

type DeleteGameConceptModalProps = Readonly<{
  gameTitle: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}>;

export const DeleteGameConceptModal = ({
  gameTitle,
  isOpen,
  onClose,
  onConfirm,
}: DeleteGameConceptModalProps) => {
  const [deleteButton, deleteTitle, closeAriaLabel, cancelButton] = useStrings(
    "deleteButton",
    "deleteGameConceptTitle",
    "closeAriaLabel",
    "cancelButton"
  );
  const confirmBody = useString("deleteGameConceptConfirmBody", gameTitle);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={styles.deleteModalHeader}>
        <h2 className={styles.deleteModalTitle}>{deleteTitle}</h2>
        <button
          type="button"
          className={styles.deleteModalClose}
          onClick={onClose}
          aria-label={closeAriaLabel}
        >
          ✕
        </button>
      </div>
      <div className={styles.deleteModalBody}>{confirmBody}</div>
      <div className={styles.deleteModalActions}>
        <button type="button" className={styles.deleteModalCancel} onClick={onClose}>
          {cancelButton}
        </button>
        <button type="button" className={styles.deleteModalConfirm} onClick={onConfirm}>
          {deleteButton}
        </button>
      </div>
    </Modal>
  );
};
